import { render, staticRenderFns } from "./MealimAnalysisDetails.vue?vue&type=template&id=fee2b45a&scoped=true"
import script from "./MealimAnalysisDetails.vue?vue&type=script&lang=js"
export * from "./MealimAnalysisDetails.vue?vue&type=script&lang=js"
import style0 from "./MealimAnalysisDetails.vue?vue&type=style&index=0&id=fee2b45a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee2b45a",
  null
  
)

export default component.exports